import { render, staticRenderFns } from "./ParamnsListStructure.vue?vue&type=template&id=036d3f36"
import script from "./ParamnsListStructure.vue?vue&type=script&lang=js"
export * from "./ParamnsListStructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports